export default {
    title_list: 'Единицы измерения',
    title_page: 'Единица измерения',
    title_create_page: 'Создать единицу измерения',
    title_edit_page: 'Изменить единицу измерения',

    filter: {
        labels: {
            title: 'Название',
        }
    },

    table: {
        labels: {
            id: 'ID',
            title: 'Название',
            type_id: 'Тип',
        }
    },

    buttons: {

    },

    form: {
        title: 'Название',
        type_id: 'Тип',
    },
}
